module.exports = __webpack_public_path__ + "static/media/counciller.3e2d380a.JPG";